<template>
  <div class="profil-container" v-if="alamat.length > 0">
    <h3 class="profil-title" v-if="formIsActive(alamat[0])">{{ alamat[0].text }}</h3>
    <p class="profil-subtitle" v-if="formIsActive(alamat[1])">{{ alamat[1].text }}</p>

    <div class="vendor-form-wrapper">
      <div v-for="(list, index) in alamat.slice(2)" :key="index" class="vendor-form" v-if="formIsActive(list)">
        <p class="vendor-form-label">
          {{ list.text }}<span v-if="list.is_mandatory" class="text-ast">*</span>
        </p>

        <textarea class="vendor-input" v-model="address" autocomplete="alamat"
          oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);"
          v-if="list.name == 'Alamat-3'" />

        <div class="vendor-input" v-if="list.name == 'Alamat-4'">
          <v-select class="style-chooser" placeholder="Pilih Negara" label="negara" :options="countries"
            v-model="choosedCountry" autocomplete="negara" />
        </div>

        <div class="vendor-input" v-if="list.name == 'Alamat-5'">
          <v-select class="style-chooser" placeholder="Pilih Provinsi" label="desc" :options="provinces"
            v-model="choosedProvince" v-if="choosedCountry && choosedCountry.id == 63" />

          <input v-else type="text" class="w-100" v-model="provinsiAsing"
            oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);"
            :placeholder="!choosedCountry ? 'Silahkan pilih negara terlebih dahulu' : 'Provinsi'"
            :disabled="!choosedCountry" />
        </div>


        <div class="vendor-input" v-if="list.name == 'Alamat-6'">
          <div class="w-full" v-if="choosedCountry">
            <input v-if="choosedCountry && choosedCountry.id !== 63" type="text" class="w-100" v-model="kotaAsing"
              oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />

            <v-select v-else class="style-chooser" placeholder="Pilih Kota" label="desc" :options="cities"
              v-model="choosedCity" autocomplete="kota" />
          </div>
          <div class="w-full" v-else>
            <input type="text" class="w-100" placeholder="Silahkan pilih negara dan provinsi terlebih dahulu"
              disabled />
          </div>
        </div>

        <div class="vendor-input" v-if="list.name == 'Alamat-7'">
          <v-select v-if="choosedCity" class="style-chooser" placeholder="Pilih Kecamatan" label="desc"
            :options="districs" v-model="choosedDistric" />

          <input v-if="!choosedCity" type="text" class="w-100"
            :placeholder="choosedCountry && choosedCountry.id !== 63 ? 'Input ini hanya untuk pilihan negara Indonesia' : 'Silahkan Pilih kota terlebih dahulu'"
            disabled />
        </div>

        <div class="vendor-input" v-if="list.name == 'Alamat-8'">
          <v-select v-if="choosedDistric" class="style-chooser" placeholder="Pilih Kelurahan" label="desc"
            :options="villages" v-model="choosedVillage" />

          <input v-if="!choosedDistric" type="text" class="w-100"
            :placeholder="choosedCountry && choosedCountry.id !== 63 ? 'Input ini hanya untuk pilihan negara Indonesia' : 'Silahkan Pilih kecamatan terlebih dahulu'"
            disabled />
        </div>

        <the-mask class="vendor-input" :mask="['######']" placeholder="Isikan kodepos" v-model="kodepos"
          v-if="list.name == 'Alamat-9'" />

        <div class="phone-input" v-if="list.name == 'Alamat-10'">
          <the-mask class="phone-input__code" :mask="['+###']" v-model="phoneCode" placeholder="eg: +62" />
          <the-mask class="phone-input__phone" :mask="['####################']" v-model="phoneNumber"
            placeholder="eg: 88292882928" />
        </div>

        <input v-if="list.name == 'Alamat-11'" type="text" class="vendor-input" v-model="emailPerusahaan"
          autocomplete="email"
          oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />

        <master-data-input-list :list="list" :step="'md_step_3'" :i="index" v-if="list.question_type !== 'default'" />
      </div>
    </div>

    <div class="profil-btn-wrapper">
      <div @click="goBack()" class="btn-landing">Kembali</div>
      <div @click="goBank()" class="btn-landing">Selanjutnya</div>
    </div>
  </div>
</template>

<script>
import { api } from '@/services/config'
import axios from 'axios'
export default {
  name: 'alamat',
  data() {
    return {
      countries: [],
      provinces: [],
      cities: [],
      districs: [],
      villages: [],
    }
  },
  created() {
    this.getCountry()
    this.getProvince()
  },
  computed: {
    alamat() {
      return this.$store.state.landingpage.md_step_3
    },
    provinsiAsing: {
      get() {
        return this.$store.state.landingpage.provinsiAsing
      },
      set(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'provinsiAsing',
          value: newValue,
        })
      },
    },
    kotaAsing: {
      get() {
        return this.$store.state.landingpage.kotaAsing
      },
      set(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'kotaAsing',
          value: newValue,
        })
      },
    },
    choosedCountry: {
      get() {
        return this.$store.state.landingpage.choosedCountry
      },
      set(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'choosedCountry',
          value: newValue,
        })

        if (newValue) {
          if (newValue.id == 63) {
            this.$store.commit('landingpage/SET_STATE_DATA', {
              name: 'phoneCode',
              value: '+62',
            })
            this.$store.commit('landingpage/SET_STATE_DATA', {
              name: 'mataUang',
              value: 'IDR',
            })
            this.$store.commit('landingpage/SET_STATE_DATA', {
              name: 'phoneDirektur',
              value: '+62',
            })
            this.$store.commit('landingpage/SET_STATE_DATA', {
              name: 'phoneKomisaris',
              value: '+62',
            })
            this.$store.commit('landingpage/SET_STATE_DATA', {
              name: 'phonePic',
              value: '+62',
            })
          }
        } else {
          this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'choosedProvince',
            value: null,
          })
          this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'choosedCity',
            value: null,
          })
          this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'choosedDistric',
            value: null,
          })
          this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'choosedVillage',
            value: null,
          })
          this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'kodepos',
            value: '',
          })
          this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'phoneCode',
            value: '',
          })
        }
      },
    },
    choosedProvince: {
      get() {
        return this.$store.state.landingpage.choosedProvince
      },
      set(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'choosedProvince',
          value: newValue,
        })
      },
    },
    choosedCity: {
      get() {
        if (this.$get(this.$store, 'state.landingpage.choosedProvince.id')) {
          this.getCity()
        }
        return this.$store.state.landingpage.choosedCity
      },
      set(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'choosedCity',
          value: newValue,
        })
      },
    },
    choosedDistric: {
      get() {
        if (this.$get(this.$store, 'state.addEdit.choosedCity.id')) {
          this.getDistric()
        }
        return this.$store.state.landingpage.choosedDistric
      },
      set(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'choosedDistric',
          value: newValue,
        })
      },
    },
    choosedVillage: {
      get() {
        if (this.$get(this.$store, 'state.addEdit.choosedDistric.id')) {
          this.getVillage()
        }
        return this.$store.state.landingpage.choosedVillage
      },
      set(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'choosedVillage',
          value: newValue,
        })
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'kodepos',
          value: newValue ? newValue.kodepos : '',
        })
      },
    },
    kodepos: {
      get() {
        return this.$store.state.landingpage.kodepos
      },
      set: function (newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'kodepos',
          value: newValue,
        })
      },
    },
    phoneCode: {
      get() {
        return this.$store.state.landingpage.phoneCode
      },
      set: function (newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'phoneCode',
          value: newValue,
        })
      },
    },
    phoneNumber: {
      get() {

        return this.$store.state.landingpage.phoneNumber
      },
      set: function (newValue) {
        // let input = newValue
        // input = input.replace(/[\W\s\._\-]+/g, '')

        // let split = 0
        // let chunk = []

        // for (let i = 0; i < input.length; i += split) {
        //   split = i < 3 ? 3 : i < 5 ? 4 : 5
        //   chunk.push(input.substr(i, split))
        // }

        // let newPhoneNumber = chunk.join(' ')
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'phoneNumber',
          value: newValue,
        })
      },
    },
    emailPerusahaan: {
      get: function () {
        return this.$store.state.landingpage.emailPerusahaan
      },
      set: function (newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'emailPerusahaan',
          value: newValue,
        })
      },
    },
    address: {
      get: function () {
        return this.$store.state.landingpage.address
      },
      set: function (newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'address',
          value: newValue,
        })
      },
    },
  },
  watch: {
    choosedCountry: function (newValue, oldValue) {
      if (newValue && newValue.id == 63) {
        this.provinsiAsing = null
        this.kotaAsing = null
        this.kodepos = null
      }
    },
    choosedProvince: function (newValue, oldValue) {
      if (newValue !== oldValue && newValue == null) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'choosedProvince',
          value: newValue,
        })
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'choosedCity',
          value: null,
        })
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'choosedDistric',
          value: null,
        })
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'choosedVillage',
          value: null,
        })
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'kodepos',
          value: null,
        })
      } else {
        this.getCity()
      }
    },
    choosedCity: function (newChoosedCity, oldChoosedCity) {
      if (newChoosedCity !== oldChoosedCity && newChoosedCity == null) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'choosedCity',
          value: newChoosedCity,
        })
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'choosedDistric',
          value: null,
        })
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'choosedVillage',
          value: null,
        })
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'kodepos',
          value: null,
        })
      } else {
        this.getDistric()
      }
    },
    choosedDistric: function (newChoosedDistric, oldChoosedDistric) {
      if (
        newChoosedDistric !== oldChoosedDistric &&
        newChoosedDistric == null
      ) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'choosedDistric',
          value: newChoosedDistric,
        })
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'choosedVillage',
          value: null,
        })
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'kodepos',
          value: null,
        })
      } else {
        this.getVillage()
      }
    },
    choosedVillage: function (newChoosedVillage, oldChoosedVillage) {
      if (
        newChoosedVillage !== oldChoosedVillage &&
        newChoosedVillage == null
      ) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'kodepos',
          value: '',
        })
      }
    },
  },
  methods: {
    checkForm() {
      let arr1 = [
        [this.address, 'Alamat'],
        [this.choosedCountry, 'Negara'],
        [this.phoneCode, 'Kode Negara'],
        [this.kodepos, 'Kode Pos'],
        [this.phoneNumber, 'Nomor Telepon'],
        [this.isEmailValid(this.emailPerusahaan), 'Email'],
      ]

      let arr = []
      let alamat = this.alamat.slice(2)
      for (let i in alamat) {
        if (alamat[i].name == 'Alamat-3' && alamat[i].is_mandatory && alamat[i].is_active) { arr.push([this.address, alamat[i].text]) }
        else if (alamat[i].name == 'Alamat-4' && alamat[i].is_mandatory && alamat[i].is_active) { arr.push([this.choosedCountry, alamat[i].text]) }
        else if (alamat[i].name == 'Alamat-5' && alamat[i].is_mandatory && alamat[i].is_active) { arr.push([this.choosedCountry && this.choosedCountry.id == 63 ? this.choosedProvince : this.provinsiAsing, alamat[i].text]) }
        else if (alamat[i].name == 'Alamat-6' && alamat[i].is_mandatory && alamat[i].is_active) { arr.push([this.choosedCountry && this.choosedCountry.id == 63 ? this.choosedCity : this.kotaAsing, alamat[i].text]) }
        else if (alamat[i].name == 'Alamat-7' && alamat[i].is_mandatory && alamat[i].is_active) { arr.push([this.choosedDistric, alamat[i].text]) }
        else if (alamat[i].name == 'Alamat-8' && alamat[i].is_mandatory && alamat[i].is_active) { arr.push([this.choosedVillage, alamat[i].text]) }
        else if (alamat[i].name == 'Alamat-9' && alamat[i].is_mandatory && alamat[i].is_active) { arr.push([this.kodepos, alamat[i].text]) }
        else if (alamat[i].name == 'Alamat-10' && alamat[i].is_mandatory && alamat[i].is_active) {
          arr.push([this.phoneCode, alamat[i].text])
          arr.push([this.phoneNumber, alamat[i].text])
        }
        else if (alamat[i].name == 'Alamat-11' && alamat[i].is_mandatory && alamat[i].is_active) { arr.push([this.isEmailValid(this.emailPerusahaan), alamat[i].text]) }
        else if (!alamat[i].is_default && alamat[i].is_active && alamat[i].is_mandatory) {
          arr.push([alamat[i].form_value, alamat[i].text])
        }
      }

      return this.multiConditions(arr)
    },
    goBack() {
      const query = this.$store.state.landingpage.query
      this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'profilebu')
    },
    goBank() {
      if (this.checkForm()) {
        this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'bank')
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'bank_step',
          value: true,
        })
      }
    },
    async getCountry() {
      const url = `${api}/api/v1/negara?page=1&limit=1000`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        this.countries = data.data
      } catch (error) { }
    },
    async getProvince() {
      const url = `${api}/api/v1/provinsi?page=1&limit=1000`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        this.provinces = data.data
      } catch (error) { }
    },
    async getCity() {
      const url = `${api}/api/v1/kota?page=1&limit=1000&provinsi=${this.$get(
        this.$store,
        'state.landingpage.choosedProvince.id'
      )}`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        this.cities = data.data
      } catch (error) { }
    },
    async getDistric() {
      const url = `${api}/api/v1/kecamatan?page=1&limit=10000&kota=${this.$get(
        this.$store,
        'state.landingpage.choosedCity.id'
      )}`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        this.districs = data.data
      } catch (error) { }
    },
    async getVillage() {
      const url = `${api}/api/v1/kelurahan?page=1&limit=1000&kecamatan=${this.$get(
        this.$store,
        'state.landingpage.choosedDistric.id'
      )}`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        this.villages = data.data
      } catch (error) { }
    },
  },
}
</script>
